import React, { useEffect, useState } from 'react'
import { TextField, Autocomplete } from '@mui/material';

export const CustomAutocomplete = (props) => {

    const {
        customId,
        customName,
        customValue, //estado de formulario
        customOnChange,
        customOptions,
        customPlaceholder,
        customDisableClearable,
        customDisabled,
        customRequired
    } = props

    const [formattedOptions, setFormattedOptions] = useState([])

    useEffect(() => {
        setFormattedOptions(customOptions)
    }, [customOptions])

    return (
        <Autocomplete
            id={customId}
            name={customName}
            size="small"
            disableClearable={customDisableClearable}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, newValue) => option?.value === newValue?.value}
            value={formattedOptions.find((option) => option.value === customValue) || null}
            onChange={customOnChange}
            renderInput={(params) => <TextField {...params} placeholder={customPlaceholder} required={customRequired}/>}
            options={formattedOptions}
            disabled={customDisabled}
        />
    )
}